import React, { ReactNode } from "react";

import Modal, {
  ModalText,
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as WarningIcon } from "src/images/warning-orange.svg";

import "./WarningModal.scss";

interface Props {
  onClose: () => void;
  upperText?: ReactNode;
  warningMessage?: ReactNode;
  objectNames?: string[];
  loading?: boolean;
  confirmAction: () => Promise<void> | void;
}

const OBJECT_ITEM_LIMIT = 3;

export const WarningModal: React.FC<Props> = (props) => {
  const {
    onClose,
    upperText,
    warningMessage,
    objectNames = [],
    loading,
    confirmAction,
  } = props;

  const handleConfirm = async () => {
    confirmAction();
    onClose();
  };

  return (
    <Modal
      variant="small"
      className="warning-modal"
      overlayClassName="warning-modal__overlay"
      onClose={onClose}
      onCancelClick={onClose}
      displayCancelButton
      closeButtonVariant="white-with-black-border"
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      confirmButtonText={
        <IDHFormattedMessage id="ws_confirm" defaultMessage="Confirm" />
      }
      confirmButtonVariant="blue"
      onConfirmClick={handleConfirm}
      confirmButtonLoading={loading}
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle>
        <WarningIcon className="warning-modal__trashcan" />
        <IDHFormattedMessage id="ws_warning" defaultMessage="Warning" />
      </ModalTitle>
      <ModalText>
        {upperText || (
          <IDHFormattedMessage
            id="ws_warning_modal_are_you_sure_you_want_to_use"
            defaultMessage="Are you sure you want to use:"
          />
        )}
      </ModalText>
      {objectNames?.length > 0 && (
        <div className="warning-modal__object-name-list">
          <ul>
            {objectNames.slice(0, OBJECT_ITEM_LIMIT).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
            {objectNames?.length > OBJECT_ITEM_LIMIT && (
              <li
                key={1000}
                className="warning-modal__object-name-list-over-limit"
              >
                <IDHFormattedMessage id="ws_and" defaultMessage="and" />
                &nbsp;{objectNames?.length - OBJECT_ITEM_LIMIT}&nbsp;
                <IDHFormattedMessage
                  id="ws_remove_modal_items_more"
                  defaultMessage="items more"
                />
              </li>
            )}
          </ul>
        </div>
      )}
      <ModalText>
        {warningMessage || (
          <IDHFormattedMessage
            id="ws_this_action_cannot_be_undone"
            defaultMessage="This action cannot be undone."
          />
        )}
      </ModalText>
    </Modal>
  );
};
